"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Media = void 0;
/**
 * @classdesc A Media represents a metadata information for the media upload
 * @property {String} sid - The server-assigned unique identifier for Media
 * @property {String} serviceSid - Service instance id which Media belongs/uploaded to
 * @property {Date} dateCreated - When the Media was created
 * @property {Date} dateUpdated - When the Media was updated
 * @property {Number} size - Size of media, bytes
 * @property {String} contentType - content type of media
 * @property {String} fileName - file name, if present, null otherwise
 */
class Media {
    constructor(config, network, data) {
        this.config = config;
        this.network = network;
        this._update(data);
    }
    get sid() { return this.state.sid; }
    get serviceSid() { return this.state.serviceSid; }
    get dateCreated() { return this.state.dateCreated; }
    get dateUpdated() { return this.state.dateUpdated; }
    get contentType() { return this.state.contentType; }
    get size() { return this.state.size; }
    get fileName() { return this.state.filename; }
    /**
     * Returns direct content URL to uploaded binary
     * @public
     * @returns {Promise<string>}
     */
    async getContentUrl() {
        let response = await this.network.get(`${this.config.baseUrl}/${this.sid}`);
        this._update(response.body);
        return Promise.resolve(this.state.contentDirectUrl);
    }
    _update(data) {
        this.state = {
            sid: data.sid,
            serviceSid: data.service_sid,
            channelSid: data.channel_sid,
            messageSid: data.message_sid,
            dateCreated: data.date_created ? new Date(data.date_created) : null,
            dateUpdated: data.date_updated ? new Date(data.date_updated) : null,
            size: data.size,
            contentType: data.content_type,
            url: data.url,
            contentUrl: data.links.content,
            contentDirectUrl: data.links.content_direct_temporary,
            filename: data.filename ? data.filename : null
        };
    }
}
exports.Media = Media;
